import { css } from '@emotion/react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { RegularDropdownComponent } from '~/_shared/baseComponents/dropdown';
import {
  ExportReportTemplates, HighPriorityExportReportTemplates,
} from '~/exportReport/template/exportReportTemplates';
import { ExportReportTemplateUploaderComponent } from '~/exportReport/templateLoader/exportReportTemplateUploader.component';
import { exportReportSetTemplate } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.actionCreators';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

const printHiddenStyle = css`
  @media print {
    display: none;
  }
`;

const templateSelectorTextStyle = css({
  margin: 0,
});

const templateDropdownStyle = css({
  width: 350,
  marginBottom: 20,
});

const highPriorityBoldStyle = css({
  fontWeight: 700,
});

const highPriorityItalicStyle = css({
  fontStyle: 'italic',
});

const highPriorityTemplateIds = new Set(HighPriorityExportReportTemplates.map(item => item.id));

const allExportReportTemplates = [...HighPriorityExportReportTemplates, ...ExportReportTemplates];

const dropdownOptions = allExportReportTemplates.map(item => ({
  value: item.id,
  name: `${item.name} (${item.id})`,
}));

export const ExportReportTemplateLoaderComponent = () => {
  const reportState = useToolsStateExportReportSelector();
  const selectedTemplateId = reportState.template.id;
  const dispatch = useDispatch();

  const onSelectedTemplateChange = (templateId: string) => {
    const newTemplate = allExportReportTemplates.find(item => item.id === templateId);
    if (!newTemplate) {
      return;
    }

    dispatch(exportReportSetTemplate(newTemplate));
  };

  const getItemStyle = useCallback((value: string) => {
    if (!highPriorityTemplateIds.has(value)) {
      return undefined;
    }
    return value.endsWith('_alt') ? highPriorityItalicStyle : highPriorityBoldStyle;
  }, []);

  return (
    <div css={printHiddenStyle}>
      <p css={templateSelectorTextStyle}>Select Template</p>
      <div css={templateDropdownStyle}>
        <RegularDropdownComponent
          value={selectedTemplateId}
          onChange={onSelectedTemplateChange}
          options={dropdownOptions}
          itemCustomStyle={getItemStyle}
          placeholder={selectedTemplateId ? 'Custom template' : 'Select a template'}
        />
      </div>

      <ExportReportTemplateUploaderComponent />
    </div>
  );
};
